export default {
    GOOGLE: {
        GAPI_KEY: "",
        reCaptcha: "6Lf7LtEZAAAAAF-tU3pDbZwtOkd9hEFVjjy3t7SM"
    }
}